(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* ================================================================
     CLEAN COLLECTION PAGINATION URL
     Keeps Shopify's internal ?page=X request working, but removes the
     page parameter from the browser address bar.
  ================================================================= */
  (function() {
    if (window.__t4sCleanCollectionPageUrlInstalled) return;
    window.__t4sCleanCollectionPageUrlInstalled = true;

    function getCleanCollectionUrl(value) {
      if (!value) return value;

      try {
        var parsedUrl = new URL(value, window.location.href);

        /* Only change collection URLs on this Shopify store. */
        if (parsedUrl.origin !== window.location.origin) return value;
        if (parsedUrl.pathname.indexOf('/collections/') === -1) return value;

        parsedUrl.searchParams.delete('page');

        var queryString = parsedUrl.searchParams.toString();

        return parsedUrl.pathname +
          (queryString ? '?' + queryString : '') +
          parsedUrl.hash;
      } catch (error) {
        return value;
      }
    }

    function cleanVisibleCollectionUrl() {
      var currentUrl = window.location.pathname +
        window.location.search +
        window.location.hash;

      var cleanUrl = getCleanCollectionUrl(window.location.href);

      if (cleanUrl && cleanUrl !== currentUrl) {
        nativeReplaceState(window.history.state, document.title, cleanUrl);
      }
    }

    var nativePushState = window.history.pushState.bind(window.history);
    var nativeReplaceState = window.history.replaceState.bind(window.history);

    /* Prevent theme AJAX from putting ?page=X back into the URL. */
    window.history.pushState = function(state, title, url) {
      var finalUrl = url;

      if (typeof url === 'string' || url instanceof URL) {
        finalUrl = getCleanCollectionUrl(url.toString());
      }

      return nativePushState(state, title, finalUrl);
    };

    window.history.replaceState = function(state, title, url) {
      var finalUrl = url;

      if (typeof url === 'string' || url instanceof URL) {
        finalUrl = getCleanCollectionUrl(url.toString());
      }

      return nativeReplaceState(state, title, finalUrl);
    };

    /* Clean a directly opened URL such as ?page=5 immediately. */
    cleanVisibleCollectionUrl();

    document.addEventListener('DOMContentLoaded', cleanVisibleCollectionUrl);
    window.addEventListener('pageshow', cleanVisibleCollectionUrl);
    window.addEventListener('popstate', function() {
      window.setTimeout(cleanVisibleCollectionUrl, 0);
    });

    /* Some theme scripts update the URL after AJAX completes. */
    document.addEventListener('click', function(event) {
      if (!event.target.closest('[data-load-more], [data-load-onscroll]')) return;

      window.setTimeout(cleanVisibleCollectionUrl, 50);
      window.setTimeout(cleanVisibleCollectionUrl, 300);
      window.setTimeout(cleanVisibleCollectionUrl, 1000);
    });
  })();

  function t4sCloneRichTextByWords(sourceEl, previewEl, moreEl, limit) {
    var usedWords = 0;
    var hasMore = false;

    function splitTextNode(text) {
      if (!text) {
        return { preview: '', more: '' };
      }

      var tokens = text.match(/\s+|\S+/g) || [];
      var previewText = '';
      var moreText = '';

      tokens.forEach(function(token) {
        var isSpace = /^\s+$/.test(token);

        if (isSpace) {
          if (usedWords < limit) {
            previewText += token;
          } else if (hasMore) {
            moreText += token;
          }
          return;
        }

        if (usedWords < limit) {
          previewText += token;
          usedWords += 1;
        } else {
          moreText += token;
          hasMore = true;
        }
      });

      return {
        preview: previewText,
        more: moreText
      };
    }

    function cloneNodeToTargets(node, previewParent, moreParent) {
      if (node.nodeType === Node.TEXT_NODE) {
        var split = splitTextNode(node.textContent);

        if (split.preview) {
          previewParent.appendChild(document.createTextNode(split.preview));
        }

        if (split.more) {
          moreParent.appendChild(document.createTextNode(split.more));
        }

        return;
      }

      if (node.nodeType !== Node.ELEMENT_NODE) return;

      var tagName = node.tagName.toLowerCase();
      if (tagName === 'script' || tagName === 'style') return;

      var previewClone = node.cloneNode(false);
      var moreClone = node.cloneNode(false);

      Array.prototype.slice.call(node.childNodes).forEach(function(child) {
        cloneNodeToTargets(child, previewClone, moreClone);
      });

      if (previewClone.textContent.trim() || previewClone.querySelector('img,svg,br')) {
        previewParent.appendChild(previewClone);
      }

      if (moreClone.textContent.trim() || moreClone.querySelector('img,svg,br')) {
        moreParent.appendChild(moreClone);
      }
    }

    function rawText(node) {
      return (node && node.textContent) ? node.textContent : '';
    }

    function needsSpaceBetween(leftNode, rightNode) {
      var leftRaw = rawText(leftNode);
      var rightRaw = rawText(rightNode);

      if (!leftRaw || !rightRaw) return false;
      if (/\s$/.test(leftRaw) || /^\s/.test(rightRaw)) return false;

      var left = leftRaw.replace(/\s+$/g, '');
      var right = rightRaw.replace(/^\s+/g, '');
      var last = left.slice(-1);
      var first = right.charAt(0);

      if (!last || !first) return false;
      if (/^[.,;:!?%\])}]/.test(first)) return false;
      if (/[([{]$/.test(last)) return false;

      return true;
    }

    function normalizeInlineSpacing(parent) {
      if (!parent) return;

      var nodes = Array.prototype.slice.call(parent.childNodes);

      for (var i = 0; i < nodes.length - 1; i++) {
        var current = nodes[i];
        var next = nodes[i + 1];

        if (needsSpaceBetween(current, next)) {
          parent.insertBefore(document.createTextNode(' '), next);
        }
      }

      Array.prototype.slice.call(parent.children).forEach(function(child) {
        normalizeInlineSpacing(child);
      });
    }

    function ensurePreviewMoreBoundarySpace() {
      if (!hasMore || !previewEl || !moreEl || !moreEl.firstChild) return;

      if (needsSpaceBetween(previewEl, moreEl)) {
        moreEl.insertBefore(document.createTextNode(' '), moreEl.firstChild);
      }
    }

    previewEl.innerHTML = '';
    moreEl.innerHTML = '';

    Array.prototype.slice.call(sourceEl.childNodes).forEach(function(node) {
      cloneNodeToTargets(node, previewEl, moreEl);
    });

    normalizeInlineSpacing(previewEl);
    normalizeInlineSpacing(moreEl);
    ensurePreviewMoreBoundarySpace();

    return hasMore;
  }

  function t4sNormalizeCollectionFaqText(value) {
    return (value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function t4sIsCollectionFaqTitle(node) {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return false;

    var text = t4sNormalizeCollectionFaqText(node.textContent);
    if (!text) return false;

    var containsFaqText = /\bfaqs?\b/i.test(text) || /frequently\s+asked\s+questions?/i.test(text);
    if (!containsFaqText) return false;

    if (t4sGetCollectionHeadingLevel(node) !== null) return true;

    var strong = t4sGetDirectStrongElement(node);
    var strongText = strong ? t4sNormalizeCollectionFaqText(strong.textContent) : '';

    if (strongText && strongText === text && text.length <= 100) return true;

    return /^(frequently\s+asked\s+questions?|faqs?)(\s*[:\-–—])?$/i.test(text);
  }

  function t4sGetCollectionHeadingLevel(node) {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return null;

    var match = /^H([1-6])$/.exec(node.tagName);
    return match ? parseInt(match[1], 10) : null;
  }

  function t4sGetDirectStrongElement(node) {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return null;

    for (var i = 0; i < node.children.length; i++) {
      var child = node.children[i];
      if (child.tagName === 'STRONG' || child.tagName === 'B') return child;
    }

    return null;
  }

  function t4sIsCollectionFaqQuestion(node) {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) return false;

    var text = t4sNormalizeCollectionFaqText(node.textContent);
    if (!text) return false;

    var headingLevel = t4sGetCollectionHeadingLevel(node);
    if (headingLevel !== null) return true;

    var tagName = node.tagName.toLowerCase();
    var strong = t4sGetDirectStrongElement(node);
    var strongText = strong ? t4sNormalizeCollectionFaqText(strong.textContent) : '';

    if ((tagName === 'p' || tagName === 'div' || tagName === 'li') && strong) {
      if (/\?$/.test(strongText) || /^(q|question)\s*\d*\s*[:.\-]/i.test(strongText)) {
        return true;
      }

      if (strongText && strongText.length === text.length) return true;
    }

    if ((tagName === 'p' || tagName === 'div') && /\?$/.test(text)) return true;
    if (/^(q|question)\s*\d*\s*[:.\-]/i.test(text)) return true;

    return false;
  }

  function t4sGetCollectionFaqQuestionText(node) {
    var strong = t4sGetDirectStrongElement(node);
    var text = strong ? strong.textContent : node.textContent;

    return t4sNormalizeCollectionFaqText(text)
      .replace(/^(q|question)\s*\d*\s*[:.\-]\s*/i, '')
      .trim();
  }

  function t4sGetInlineCollectionFaqAnswer(node) {
    var strong = t4sGetDirectStrongElement(node);
    if (!strong) return null;

    var clone = node.cloneNode(true);
    var cloneStrong = t4sGetDirectStrongElement(clone);
    if (cloneStrong) cloneStrong.remove();

    Array.prototype.slice.call(clone.querySelectorAll('br')).forEach(function(br) {
      if (!br.previousSibling && !br.nextSibling) br.remove();
    });

    var answerText = t4sNormalizeCollectionFaqText(clone.textContent)
      .replace(/^[:\-–—]\s*/, '')
      .trim();

    if (!answerText && !clone.querySelector('img,video,iframe,ul,ol,table')) return null;

    return clone;
  }

  function t4sBuildCollectionFaqAccordion(wrapper, source) {
    var target = wrapper.querySelector('[data-collection-faqs]');
    if (!target || !source) return false;

    target.innerHTML = '';
    target.setAttribute('hidden', 'hidden');

    var sourceElements = Array.prototype.slice.call(source.children);
    var faqTitleNode = null;

    for (var i = 0; i < sourceElements.length; i++) {
      if (t4sIsCollectionFaqTitle(sourceElements[i])) {
        faqTitleNode = sourceElements[i];
        break;
      }
    }

    if (!faqTitleNode) return false;

    var faqTitle = t4sNormalizeCollectionFaqText(faqTitleNode.textContent) || 'Frequently Asked Questions';
    var faqTitleLevel = t4sGetCollectionHeadingLevel(faqTitleNode) || 2;
    var faqMarker = document.createComment('collection-faq-position');
    faqTitleNode.parentNode.insertBefore(faqMarker, faqTitleNode);
    var faqNodes = [];
    var cursor = faqTitleNode.nextSibling;

    while (cursor) {
      var nextCursor = cursor.nextSibling;
      var cursorHeadingLevel = t4sGetCollectionHeadingLevel(cursor);
      var isQuestion = t4sIsCollectionFaqQuestion(cursor);

      /* Stop when another equal/higher-level non-question section begins. */
      if (
        cursor.nodeType === Node.ELEMENT_NODE &&
        cursorHeadingLevel !== null &&
        cursorHeadingLevel <= faqTitleLevel &&
        !isQuestion
      ) {
        break;
      }

      faqNodes.push(cursor);
      cursor = nextCursor;
    }

    var faqContent = document.createElement('div');
    faqNodes.forEach(function(node) {
      faqContent.appendChild(node);
    });
    faqTitleNode.remove();

    var items = [];
    var introNodes = [];
    var currentItem = null;

    function saveCurrentItem() {
      if (!currentItem) return;

      var hasAnswerContent = currentItem.answerNodes.some(function(answerNode) {
        return t4sNormalizeCollectionFaqText(answerNode.textContent) ||
          (answerNode.querySelector && answerNode.querySelector('img,video,iframe,ul,ol,table'));
      });

      if (currentItem.question && hasAnswerContent) items.push(currentItem);
      currentItem = null;
    }

    Array.prototype.slice.call(faqContent.childNodes).forEach(function(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        if (!t4sNormalizeCollectionFaqText(node.textContent)) return;

        if (currentItem) {
          currentItem.answerNodes.push(node.cloneNode(true));
        } else {
          introNodes.push(node.cloneNode(true));
        }
        return;
      }

      if (node.nodeType !== Node.ELEMENT_NODE) return;

      if (t4sIsCollectionFaqQuestion(node)) {
        saveCurrentItem();

        currentItem = {
          question: t4sGetCollectionFaqQuestionText(node),
          answerNodes: []
        };

        var inlineAnswer = t4sGetInlineCollectionFaqAnswer(node);
        if (inlineAnswer) currentItem.answerNodes.push(inlineAnswer);
      } else if (currentItem) {
        currentItem.answerNodes.push(node.cloneNode(true));
      } else {
        introNodes.push(node.cloneNode(true));
      }
    });

    saveCurrentItem();

    if (!items.length) {
      /* Restore the original FAQ markup in its original position. */
      source.insertBefore(faqTitleNode, faqMarker);
      while (faqContent.firstChild) source.insertBefore(faqContent.firstChild, faqMarker);
      faqMarker.remove();
      return false;
    }

    faqMarker.remove();

    var title = document.createElement('h2');
    title.className = 't4s-collection-faqs__title';
    title.textContent = faqTitle;
    target.appendChild(title);

    if (introNodes.length) {
      var intro = document.createElement('div');
      intro.className = 't4s-collection-faqs__intro';
      introNodes.forEach(function(node) {
        intro.appendChild(node);
      });

      if (t4sNormalizeCollectionFaqText(intro.textContent) || intro.querySelector('img,video,iframe,ul,ol,table')) {
        target.appendChild(intro);
      }
    }

    var list = document.createElement('div');
    list.className = 't4s-collection-faqs__list';

    items.forEach(function(item) {
      var details = document.createElement('details');
      details.className = 't4s-collection-faqs__item';

      var summary = document.createElement('summary');
      summary.className = 't4s-collection-faqs__question';
      summary.textContent = item.question;

      var answer = document.createElement('div');
      answer.className = 't4s-collection-faqs__answer';
      item.answerNodes.forEach(function(node) {
        answer.appendChild(node);
      });

      details.appendChild(summary);
      details.appendChild(answer);

      /* Keep only one FAQ item open at a time. */
      details.addEventListener('toggle', function() {
        if (!details.open) return;

        Array.prototype.slice.call(list.querySelectorAll('details[open]')).forEach(function(otherDetails) {
          if (otherDetails !== details) otherDetails.open = false;
        });
      });

      list.appendChild(details);
    });

    target.appendChild(list);
    target.removeAttribute('hidden');

    return true;
  }

  function t4sInitCollectionDescriptionToggle() {
    document.querySelectorAll('[data-collection-desc-toggle]').forEach(function(wrapper) {
      if (wrapper.dataset.initialized === 'true') return;

      var source = wrapper.querySelector('.t4s-collection-desc-toggle__source');
      var descriptionText = wrapper.querySelector('[data-collection-description-text]');
      var preview = wrapper.querySelector('.t4s-collection-desc-toggle__preview');
      var more = wrapper.querySelector('.t4s-collection-desc-toggle__more');
      var moreText = wrapper.querySelector('[data-collection-more-text]');
      var dots = wrapper.querySelector('.t4s-collection-desc-toggle__dots');
      var showMoreButton = wrapper.querySelector('[data-collection-show-more]');
      var showLessButton = wrapper.querySelector('[data-collection-show-less]');
      var limit = parseInt(wrapper.getAttribute('data-limit'), 10) || 150;

      if (!source || !descriptionText || !preview || !more || !moreText || !showMoreButton || !showLessButton) return;

      /* FAQs are built inside the hidden Show More container. */
      var hasFaqAccordion = t4sBuildCollectionFaqAccordion(wrapper, source);

      var hasNormalDescription = Boolean(
        t4sNormalizeCollectionFaqText(source.textContent) ||
        source.querySelector('img,video,iframe,ul,ol,table')
      );

      if (!hasNormalDescription && !hasFaqAccordion) {
        descriptionText.setAttribute('hidden', 'hidden');
        preview.innerHTML = '';
        moreText.innerHTML = '';
        if (dots) dots.style.display = 'none';
        showMoreButton.style.display = 'none';
        showLessButton.style.display = 'none';
        more.setAttribute('hidden', 'hidden');
      } else {
        descriptionText.removeAttribute('hidden');

        var hasMoreDescription = false;

        if (hasNormalDescription) {
          hasMoreDescription = t4sCloneRichTextByWords(source, preview, moreText, limit);
        } else {
          preview.innerHTML = '';
          moreText.innerHTML = '';
        }

        /* Always keep FAQs inside Show More, even when the normal text is short. */
        var hasExpandableContent = hasMoreDescription || hasFaqAccordion;

        if (!hasExpandableContent) {
          if (dots) dots.style.display = 'none';
          showMoreButton.style.display = 'none';
          showLessButton.style.display = 'none';
          more.setAttribute('hidden', 'hidden');
        } else {
          wrapper.dataset.showCollapsedDots = hasNormalDescription ? 'true' : 'false';
          if (dots) dots.style.display = hasNormalDescription ? 'inline' : 'none';
          showMoreButton.style.display = 'inline-block';
          showLessButton.style.display = 'inline-block';
          showMoreButton.setAttribute('aria-expanded', 'false');
          showLessButton.setAttribute('aria-expanded', 'true');
          more.setAttribute('hidden', 'hidden');
        }
      }

      wrapper.dataset.initialized = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', t4sInitCollectionDescriptionToggle);
  document.addEventListener('shopify:section:load', t4sInitCollectionDescriptionToggle);

  document.addEventListener('click', function(event) {
    var showMoreButton = event.target.closest('[data-collection-show-more]');
    var showLessButton = event.target.closest('[data-collection-show-less]');

    if (!showMoreButton && !showLessButton) return;

    var clickedButton = showMoreButton || showLessButton;
    var wrapper = clickedButton.closest('[data-collection-desc-toggle]');
    if (!wrapper) return;

    var moreContent = wrapper.querySelector('.t4s-collection-desc-toggle__more');
    var dots = wrapper.querySelector('.t4s-collection-desc-toggle__dots');
    var collapsedButton = wrapper.querySelector('[data-collection-show-more]');

    if (!moreContent || !collapsedButton) return;

    if (showMoreButton) {
      moreContent.removeAttribute('hidden');
      if (dots) dots.style.display = 'none';
      collapsedButton.style.display = 'none';
      collapsedButton.setAttribute('aria-expanded', 'true');
    } else {
      moreContent.setAttribute('hidden', 'hidden');
      collapsedButton.style.display = 'inline-block';
      collapsedButton.setAttribute('aria-expanded', 'false');

      if (dots) {
        dots.style.display = wrapper.dataset.showCollapsedDots === 'true' ? 'inline' : 'none';
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
